module.exports = __webpack_public_path__ + "static/img/huapai1.c1158ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huapai1.png
// module id = L/hC
// module chunks = 1